import { Injectable } from '@angular/core';
import { StkmqServicePkg } from '../entity/stkmqPkg.service';

@Injectable({
  providedIn: 'root'
})
export class StkmqService extends StkmqServicePkg {
  constructor() {
    super();
  }


}


